// extracted by mini-css-extract-plugin
export default {"menuContainer":"SlaSubMenu_menuContainer__1gdpS"};